
window.onload= function() {
  
  
/*
if( document.getElementById("features_sana")){
    var features_sana = document.getElementById("features_sana");
    var description_sana = document.getElementById("description_sana");
    var features_tab_sana = document.getElementById("features_tab_sana");
    var description_tab_sana = document.getElementById("description_tab_sana");
    var video_sana = document.getElementById("video_sana");
    var video_tab_sana = document.getElementById("video_tab_sana");

    features_sana.addEventListener("click", function(){
        features_tab_sana.style.display = "block";
        description_tab_sana.style.display = "none";
        video_tab_sana.style.display = "none";
        features_sana.style.backgroundColor = '#f04f36';
        features_sana.style.color = '#fff';
        description_sana.style.backgroundColor = '#fff';
        description_sana.style.color = '#1d1d1d';
        video_sana.style.backgroundColor = '#fff';
        video_sana.style.color = '#1d1d1d';
        
    }, false);
    description_sana.addEventListener("click", function(){
        features_tab_sana.style.display = "none";
        description_tab_sana.style.display = "block";
        video_tab_sana.style.display = "none";
        description_sana.style.backgroundColor = '#f04f36';
        description_sana.style.color = '#fff';
        video_sana.style.backgroundColor = '#fff';
        video_sana.style.color = '#1d1d1d';
        features_sana.style.backgroundColor = '#fff';
        features_sana.style.color = '#1d1d1d';
        
    }, false);
    video_sana.addEventListener("click", function(){
        features_tab_sana.style.display = "none";
        description_tab_sana.style.display = "none";
        video_tab_sana.style.display = "block";
        video_sana.style.backgroundColor = '#f04f36';
        video_sana.style.color = '#fff';
        features_sana.style.backgroundColor = '#fff';
        features_sana.style.color = '#1d1d1d';
        description_sana.style.backgroundColor = '#fff';
        description_sana.style.color = '#1d1d1d';

    }, false);
}*/
if (window.innerWidth < 769) {
  if(document.querySelector('.featured-collection__container .home-section--content')){
    console.log('in');
    var parent = document.querySelector('.featured-collection__container .home-section--title');
    parent.innerHTML += "<br><div class='swipable'>Swipe <img style='margin-bottom:-5px' width='30px' src='https://cdn.shopify.com/s/files/1/0614/6464/1749/files/swipe.png?v=1649342425'> to see more products</div>";
  }
}

if( document.getElementById("features_sana")){
    var features_sana = document.getElementById("features_sana");
    var description_sana = document.getElementById("description_sana");
    var features_tab_sana = document.getElementById("features_tab_sana");
    var description_tab_sana = document.getElementById("description_tab_sana");
    console.log(description_sana.text());

    features_sana.addEventListener("click", function(){
        features_tab_sana.style.display = "block";
        description_tab_sana.style.display = "none";
        features_sana.style.backgroundColor = '#F7F7F7';
        description_sana.style.backgroundColor = '#fff';
        

    }, false);
    description_sana.addEventListener("click", function(){
        features_tab_sana.style.display = "none";
        description_tab_sana.style.display = "block";
        description_sana.style.backgroundColor = '#F7F7F7';
        features_sana.style.backgroundColor = '#fff';
        
    }, false);
  }

};
